import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/product/${product.id}`)}
      className="product-card group"
      data-testid={`product-card-${product.sku}`}
    >
      <div className="aspect-square bg-background-subtle rounded-lg mb-4 flex items-center justify-center overflow-hidden">
        <img
          src={product.product_image || "https://images.unsplash.com/photo-1589807502991-d64e6459096c?crop=entropy&cs=srgb&fm=jpg&q=85"}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="space-y-2">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-heading font-semibold text-lg text-text-primary" data-testid={`product-name-${product.sku}`}>
              {product.name}
            </h3>
            <p className="text-xs text-text-muted font-mono">{product.concentration}</p>
          </div>
          <span className="font-mono text-sm text-text-secondary font-medium" data-testid={`product-price-${product.sku}`}>
            ${product.price} AUD
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="inline-block px-2 py-1 bg-accent-subtle text-accent-main text-xs font-medium rounded">
            {product.category}
          </span>
          <span className="inline-block px-2 py-1 bg-slate-100 text-slate-700 text-xs font-mono">
            {product.purity}
          </span>
          {!product.in_stock && (
            <span className="inline-block px-2 py-1 bg-error/10 text-error text-xs font-medium rounded">
              Out of Stock
            </span>
          )}
          {product.in_stock && product.stock_count <= 10 && (
            <span className="inline-block px-2 py-1 bg-warning/10 text-warning text-xs font-medium rounded">
              Low Stock
            </span>
          )}
        </div>

        <p className="text-sm text-text-secondary line-clamp-2">
          {product.description}
        </p>
      </div>
    </div>
  );
};

export default ProductCard;
